import React from "react";
import styled from "styled-components";

const FormLabel = ({ children, htmlFor, ...props }) => {
  return (
    <Label htmlFor={htmlFor} {...props}>
      {children}
    </Label>
  );
};

const Label = styled.label`
  display: flex;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export default FormLabel;